module.exports = __webpack_public_path__ + "img/2-4.bce7ce90.jpg";